import { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import Image1 from '../assets/carrusel1.svg';
import Image2 from '../assets/carrusel2.svg';
import Image3 from '../assets/carrusel3.svg';
import Image4 from '../assets/carrusel4.svg';

const Carrusel = () => {
  const { t } = useTranslation();

  const baseStyles = {
    containerLeft: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "center",
    },
    title: {
      display: "flex",
      alignItems: "flex-start",
    },
    DescriptionB: {
      display: "block",
      textAlign: "left",
      lineHeight: "140%",
    },
    DescriptionC: {
      display: "block",
      textAlign: "start",
      paddingTop: "1%",
    },
  };

  // Imágenes para cada card
  const images = [
    <img
      src={Image1}
      alt="Gráfico"
      className="transition duration-500 ease-in-out transform hover:scale-110 hover:rotate-12  w-full h-[350px] mb:h-[250px] 2xl:h-[500px] mb:mb-4"
    />,
    <img
      src={Image2}
      alt="Gráfico"
      className="transition duration-500 ease-in-out transform hover:scale-90 hover:rotate-20 w-full h-[350px] mb:h-[250px] 2xl:h-[500px] mb:mb-4"
    />,
    <img
      src={Image3}
      alt="Gráfico"
      className="transition duration-500 ease-in-out transform hover:scale-110 hover:rotate-12 w-full h-[350px] mb:h-[250px] 2xl:h-[500px] mb:mb-4"
    />,
    <img
      src={Image4}
      alt="Gráfico"
      className="transition duration-500 ease-in-out transform hover:scale-110 hover:rotate-12 w-full h-[350px] mb:h-[250px] 2xl:h-[500px] mb:mb-4"
    />,
  ];

  // Obtiene las tarjetas traducidas y les asigna la imagen correspondiente
  const cards = t('actionSection.cards', { returnObjects: true }).map((card, idx) => ({
    ...card,
    image: images[idx],
    gridColumns: "md:grid-cols-[auto,auto]",
    style: { ...baseStyles }
  }));

  // Estado para controlar la tarjeta actual
  const [currentIndex, setCurrentIndex] = useState(0);
  const [userInteracted, setUserInteracted] = useState(false);

  // Funciones de navegación
  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? cards.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === cards.length - 1 ? 0 : prev + 1));
  };

  // Navegación directa por botón de título
  const goToCard = (index) => {
    setCurrentIndex(index);
    setUserInteracted(true);
  };

  // Automático si no hay interacción
  useEffect(() => {
    if (!userInteracted) {
      const timer = setTimeout(() => {
        setCurrentIndex((prev) => (prev === cards.length - 1 ? 0 : prev + 1));
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [currentIndex, userInteracted, cards.length]);

  // Reiniciar el estado de interacción después de 10 segundos
  useEffect(() => {
    if (userInteracted) {
      const resetTimer = setTimeout(() => setUserInteracted(false), 10000);
      return () => clearTimeout(resetTimer);
    }
  }, [userInteracted]);

  const data = cards[currentIndex];

  return (
    <section className="bg-white " id="carrusel">
      <div className="divider-conteiner text-center space-y-0 mb:space-y-1">
        <h1 className="font-sans text-secondary font-bold resp-h3">{t('actionSection.title')}</h1>
        <p className="hero-p resp-h2" style={{ lineHeight: "130%" }}>{t('actionSection.subtitle')}</p>
      </div>
      <div className="flex flex-col p-8 mb:py-4 mb:px-0 mx-16 mb:mx-8 mb:space-y-2 ">
        <div className="mb:h-[110px] h-full grid grid-cols-2 md:flex md:flex-wrap">
          {cards.map((card, index) => (
            <button
              key={index}
              onClick={() => goToCard(index)}
              disabled={currentIndex === index}
              className={`
                font-archivo font-bold text-body3 mb:text-h3 transition-colors duration-300 flex-1 
                p-3 border-[3px]
                ${currentIndex === index
                  ? "border-[#FF00B1] text-[#FF00B1] cursor-not-allowed"
                  : "border-[#FFB0E7] text-[#FFB0E7] hover:bg-pink-600 cursor-pointer"
                }
                ${(index !== 0 && currentIndex !== index) ? "md:border-l-0 " : ""}
                ${index === currentIndex - 1 ? "md:border-r-0 " : ""}
                ${index === currentIndex + 1 ? "md:border-l-0 " : ""}
                md:rounded-none

                ${index === currentIndex ? "mb:border-l-[3px] mb:border-r-[3px] mb:border-t-[3px] mb:border-b-[3px]" : ""}
                ${currentIndex === 1 && index === 0 ? "mb:border-r-0" : ""}
                ${currentIndex === 2 && index === 0 ? "mb:border-b-0" : ""}
                ${currentIndex === 3 && index === 2 ? "mb:border-r-0" : ""}
                ${currentIndex === 3 && index === 1 ? "mb:border-b-0" : ""}

                ${index === 0 ? "mb:rounded-tl-[20px]  md:rounded-bl-[20px] md:rounded-tl-[20px]" : ""}
                ${index === 1 ? "rounded-tr-[20px] mb:border-l-0" : ""}
                ${index === 2 ? "rounded-bl-[20px] mb:border-t-0" : ""}
                ${index === 3 ? "rounded-br-[20px]  mb:border-l-0 mb:border-t-0 md:rounded-tr-[20px] md:rounded-br-[20px]" : ""}
              `}
            >
              {card.title}
            </button>
          ))}
        </div>
        <div className={`mb:h-[470px] my-8 mx-16 mb:m-0 overflow-hidden grid grid-cols-1 ${data.gridColumns ? data.gridColumns : "md:grid-cols-auto"}`} >
          {/* Columna Izquierda */}
          <div className="mb:p-4 p-14  mb:space-y-4 space-y-8" style={data.style?.containerLeft || {}}>
            <div className="mb:space-y-2">
              <h2 className=" font-archivo text-textgrey font-bold text-h4 mb:text-h1 mb-1" style={data.style?.title || {}}>
                {data.title}
              </h2>
              <p className="font-sans hero-p text-body5 break-words mb:text-h3 mb:font-normal" style={data.style?.DescriptionB || {}}>
                {parse(data.descriptionB)}
              </p>
              <p className=" font-sans hero-p text-body5 break-words mb:text-h3" style={data.style?.DescriptionC || {}}>
                {parse(data.descriptionC)}
              </p>
            </div>
            <button className=" font-archivo btn-primary text-body5 mb:text-h3 "
              onClick={() => window.open("https://wa.toolia.site/cursos2tor", "_blank")}>
              {t('actionSection.demo_btn')}
            </button>
          </div>
          <div>{data.image}</div>
        </div>
      </div>
    </section>
  );
};

export default Carrusel;